import lunr from "lunr";
import stemmer from "lunr-languages/lunr.stemmer.support";
import pt from "lunr-languages/lunr.pt";

stemmer(lunr);
pt(lunr);

const search_fields = ["clinicalData", "findings", "report"];

const phrases_field = "report";
const min_phrase_length = 10;

export { lunr, search_fields, phrases_field, min_phrase_length };
